import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
    Field,
    reduxForm,
    autofill,
    untouch,
    updateSyncErrors,
} from 'redux-form';
import { isNull, get, includes } from 'lodash';
import axios from 'axios';

import { COMMON_COUNTRY, countryData } from '../../utilities/countries';
import { getStateList } from '../../store/signup/signupAction';
import { basicFormData } from '../../utilities/constants';
import RenderField from '../../components/RenderField';
import RenderCommonSelect from '../../components/RenderCommonSelect';
import Captcha from '../../components/Captcha';
import { required } from '../../utilities/validations';

/**
 * basic details form componeny
 * @param {*} props
 */
const BasicDetails = (props) => {
    const history = useHistory();
    const {
        handleSubmit,
        getStateList,
        needDomain,
        stateList,
        autofill,
        setLoading,
        initialValues,
        needCaptcha = false,
        domainPurchaseErrors,
    } = props;
    const [allowStateChange, setAllowStateChange] = useState(
        get(initialValues, 'state') ? false : true
    );
    const ourRequest = axios.CancelToken.source();
    useEffect(() => {
        if (isNull(needDomain)) {
            history.push('/need-domain');
        }
    }, [needDomain, history]);

    useEffect(() => {
        if (allowStateChange) {
            setLoading(true);
            getStateList(countryData[0].options[0].code).then((res) => {
                autofill('countryCode', '+' + get(res, 'callingCode'));
                autofill('state', get(res, 'states.0.stateKey', ''));
                setLoading(false);
                setAllowStateChange(false);
            });
        }
    }, [getStateList, setLoading, allowStateChange, autofill]);

    /**
     * generates the country options for the select
     */
    const generateCountryOptions = () => {
        return countryData.map((data) => (
            <optgroup key={data.label} label={data.label} placeholder="Select Country">
                {data.options.map((country) => (
                    <option key={country.code} value={country.code}>
                        {country.name}
                    </option>
                ))}
            </optgroup>
        ));
    };
    /**
     * Generates the states options for the state component
     * @param {*} stateList
     */
    const generateStateOptions = (stateList) => {
        return (
            <>
                <option value="" key={null}>
                    Select State
                </option>
                {stateList.map((state) => (
                    <option key={state.stateKey} value={state.stateKey}>
                        {state.label}
                    </option>
                ))}
            </>
        );
    };
    /**
     * Onchange handler for country select
     * @param {*} e
     * @param {*} value
     * @param {*} prevValue
     * @param {*} name
     */
    const selectOnchange = (e, value, prevValue, name) => {
        setAllowStateChange(false);

        setLoading(true);
        // ourRequest.cancel();
        getStateList(value, ourRequest).then((res) => {
            autofill('state', get(res, 'states.0.stateKey', ''));
            untouch('signup', 'state');
            autofill(
                'countryCode',

                '+' +
                    get(
                        res,
                        'callingCode',
                        get(initialValues, 'countryCode', '')
                    )
            );
            setLoading(false);
        });
    };
    /**
     * Renders the country and state select field
     * @param {*} fieldElement
     */
    const renderSelectField = (fieldElement) => {
        if (fieldElement.optionsFrom === 'country') {
            return (
                <>
                    <Field
                        name={fieldElement.name}
                        component={RenderCommonSelect}
                        placeholder={fieldElement.placeholder}
                        onChange={selectOnchange}
                        className="form-control"
                        options={() => generateCountryOptions()}
                        validate={fieldElement.validator}
                        normalize={get(fieldElement, 'normalize')}
                    ></Field>
                    <i className="arrow-d"></i>
                </>
            );
        } else if (fieldElement.optionsFrom === 'state') {
            return (
                <>
                    {stateList.length > 0 ? (
                        <>
                            <Field
                                name={fieldElement.name}
                                component={RenderCommonSelect}
                                placeholder={fieldElement.placeholder}
                                className="form-control"
                                validate={fieldElement.validator}
                                options={() => generateStateOptions(stateList)}
                            ></Field>
                            <i className="arrow-d"></i>
                        </>
                    ) : (
                        <Field
                            name={fieldElement.name}
                            component={RenderField}
                            type="text"
                            placeholder={fieldElement.placeholder}
                            className="form-control"
                            validate={fieldElement.validator}
                            normalize={get(fieldElement, 'normalize')}
                        />
                    )}
                </>
            );
        } else {
            return null;
        }
    };
    /**
     * Error class handler
     * @param {*} name
     */
    const renderErrorClass = (name) => {
        if (name !== 'zipcode') {
            return includes(domainPurchaseErrors, name);
        } else if (name === 'phoneNumber') {
            return includes(domainPurchaseErrors, 'phone');
        } else {
            return includes(domainPurchaseErrors, 'postalCode');
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="form-block">
                {basicFormData.map((rowElements, index) => {
                    return (
                        <div key={index} className="row">
                            {rowElements.rowData.map((fieldElement) => (
                                <div
                                    key={fieldElement.id}
                                    className="form-group col-2"
                                >
                                    {fieldElement.optionsFrom ? (
                                        renderSelectField(fieldElement)
                                    ) : (
                                        <>
                                            {fieldElement.name ===
                                            'phoneNumber' ? (
                                                <div className="phone-w-code">
                                                    <Field
                                                        component="input"
                                                        type="string"
                                                        name="countryCode"
                                                        disabled={true}
                                                        className="country-code form-control "
                                                        normalize={get(
                                                            fieldElement,
                                                            'normalize'
                                                        )}
                                                    />
                                                    <Field
                                                        name={fieldElement.name}
                                                        component={RenderField}
                                                        type={fieldElement.type}
                                                        className={`form-control ${
                                                            renderErrorClass(
                                                                fieldElement.name
                                                            )
                                                                ? 'inf-error'
                                                                : ''
                                                        }`}
                                                        placeholder={
                                                            fieldElement.placeholder
                                                        }
                                                        validate={
                                                            fieldElement.validator
                                                        }
                                                        normalize={get(
                                                            fieldElement,
                                                            'normalize'
                                                        )}
                                                        format={get(
                                                            fieldElement,
                                                            'formattor'
                                                        )}
                                                    />
                                                </div>
                                            ) : (
                                                <Field
                                                    name={fieldElement.name}
                                                    component={RenderField}
                                                    type={fieldElement.type}
                                                    className={`form-control ${
                                                        renderErrorClass(
                                                            fieldElement.name
                                                        )
                                                            ? 'inf-error'
                                                            : ''
                                                    }`}
                                                    placeholder={
                                                        fieldElement.placeholder
                                                    }
                                                    validate={
                                                        fieldElement.validator
                                                    }
                                                    normalize={get(
                                                        fieldElement,
                                                        'normalize'
                                                    )}
                                                />
                                            )}
                                        </>
                                    )}
                                </div>
                            ))}
                        </div>
                    );
                })}
                {needCaptcha && (
                    <div className="row">
                        <div className="form-group col-2">
                            <Field
                                name="captcharesponse"
                                component={Captcha}
                                validate={required}
                            />
                        </div>
                    </div>
                )}
            </div>
        </form>
    );
};

const mapDispatchToProps = {
    getStateList,
    autofill,
    updateSyncErrors,
};
const mapStateToProps = (store, props) => ({
    needDomain: get(store, 'signupReducer.needDomain', null),
    stateList: get(store, 'signupReducer.stateData.states', []),
    initialValues: get(store, 'signupReducer.getDomain.formData')
        ? { ...get(store, 'signupReducer.getDomain.formData') }
        : {
              ...props.initialValues,
              country: get(
                  props,
                  'initialValues.country',
                  COMMON_COUNTRY[0].code
              ),
              state: get(props, 'initialValues.state', ''),
          },
    formStateValue: get(store, 'form.signup.values.state'),
    onSubmit: props.submit,
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(
    reduxForm({
        form: 'signup', // a unique identifier for this form
    })(BasicDetails)
);
